import { AggregationPeriod } from 'types/misc';
import { parseMomentUtc } from 'utils/dates';

export const isDateMidInterval = (
  effectiveDate: string,
  aggregation: AggregationPeriod
) => {
  const appliedEffectiveDateMoment =
    parseMomentUtc(effectiveDate).startOf('month');
  return !appliedEffectiveDateMoment
    .clone()
    .startOf(aggregation)
    .isSame(appliedEffectiveDateMoment);
};
